import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "balticroots_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, variant, qty = 1) => {
    setItems((prev) => {
      const key = variant.id;
      const existing = prev.find((i) => i.variant_id === key);
      if (existing) {
        return prev.map((i) => i.variant_id === key ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        variant_id: variant.id,
        product_id: product.id,
        handle: product.handle,
        title: product.title,
        variant_title: variant.title,
        price: parseFloat(variant.price),
        image: product.images?.[0],
        quantity: qty,
      }];
    });
    setIsOpen(true);
  }, []);

  const removeItem = useCallback((variantId) => {
    setItems((prev) => prev.filter((i) => i.variant_id !== variantId));
  }, []);

  const updateQty = useCallback((variantId, qty) => {
    if (qty <= 0) return removeItem(variantId);
    setItems((prev) => prev.map((i) => i.variant_id === variantId ? { ...i, quantity: qty } : i));
  }, [removeItem]);

  const clear = useCallback(() => setItems([]), []);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, isOpen, setIsOpen, addItem, removeItem, updateQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
};
